import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import GitHubLogo from '../github-logo';
import SignUpForm from 'src/views/components/signup-form';

// import './library-hero.css';

const LibraryHero = ({authenticated, signOut}) => (
	<div>
    <div className="hero">
		<div className="hero__overlay hero__overlay--gradient"></div>
		<div className="hero__mask"></div>
		<div className="hero__inner">
			<div className="container">
				<div className="hero__content" style={{minHeight:'calc( 10vh - 50px)'}}>
					<div className="hero__content__inner" id='navConverter'>
						<h1 className="hero__title" style={{fontWeight:'600', color:'#fff'}}>Little Lingua Library</h1>
						<p className="hero__text" style={{textAlign:'center'}}>Little Lingua combines all the best elements of running a real-life language school, and applies them to an online learning environment for you. Join now for early access and to get our expert language learning tips:</p>
						{/* <a href="#" className="button button__accent">Get Early Access</a>
						<a href="#" className="button hero__button">Learn more</a> */}
						{/* <SignUpForm message="Get early access"/> */}

					</div>
				</div>
			</div>
		</div>
	</div>
	<div className="hero__sub">
		<span id="scrollToNext" className="scroll">
			<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" className='hero__sub__down' fill="currentColor" width="512px" height="512px" viewBox="0 0 512 512" style={{enableBackground:'new 0 0 512 512'}}>
      <path d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3z"/>
      </svg>
		</span>
	</div>
	</div>
);

LibraryHero.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  signOut: PropTypes.func.isRequired
};


export default LibraryHero;



// WEBPACK FOOTER //
// ./src/views/components/library-hero/library-hero.js